import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { IAddresshistory } from 'src/app/models/IMedicationHistoryDTO';
import _ from 'lodash'

@Component({
  selector: 'app-address_history',
  templateUrl: './address_history.component.html',
  styleUrls: ['./address_history.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class AddressHistoryComponent implements OnInit {
  secondaryAddress1: string;
  columnsToDisplay = ['address1', 'address2', 'address3', 'state', 'city', 'postalCode', 'postalExCode'];
  columnsToDisplay1 = ['secondaryAddress1', 'secondaryAddress2', 'secondaryState', 'secondaryCity', 'secondaryZipCode', 'secondaryPostalExCode'];
  //, 'homePhone', 'workPhone', 'fax', 'cellPhone', 'emailId', 'createdBy', 'createdOn'
  addresshistory: IAddresshistory[] = [];
  dataSource = new MatTableDataSource(this.addresshistory);
  dataSource1 = new MatTableDataSource(this.addresshistory);
  expandedElement: any | null;
  addresshistoryform: FormGroup;
  primaryaddress: IAddresshistory[];
  secondaryaddress: IAddresshistory[];
  constructor(
    public dialogRef: MatDialogRef<AddressHistoryComponent>, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: IAddresshistory[], private formBuilder: FormBuilder
    , private schedulerservice: SchedularServiceService, private toastr: ToastrService
    , private spinner: NgxSpinnerService) {
    this.spinner.show();
    this.primaryaddress = [];
    this.secondaryaddress = [];
    this.primaryaddress = data.filter((t, n, a) => a.findIndex(x => x.address1 === t.address1 && x.address2 === t.address2 && x.state === t.state && x.city === t.city && x.postalCode === t.postalCode && x.postalExCode === t.postalExCode && x.createdOn === t.createdOn) === n);//.sort((c, d) => c.createdOn.toLowerCase() > d.createdOn.toLowerCase() ? 1 : -1);
    if (this.primaryaddress.length > 1) {
      var descprimaryaddresslist = _.orderBy(this.primaryaddress, [(obj) => new Date(obj.modifiedOn)], ['desc']);
      this.dataSource.data = descprimaryaddresslist.slice(1);
      //remove last record .slice(0, -1);
    }
    this.secondaryaddress = data.filter((t, n, a) => a.findIndex(x => x.secondaryAddress1 === t.secondaryAddress1 && x.secondaryAddress2 === t.secondaryAddress2 && x.secondaryState === t.secondaryState && x.secondaryCity === t.secondaryCity && x.secondaryZipCode === t.secondaryZipCode && x.secondaryPostalExCode === t.secondaryPostalExCode && x.createdOn === t.createdOn) === n);//.sort((e, f) => e.createdOn.toLowerCase() > f.createdOn.toLowerCase() ? 1 : -1);
    if (this.secondaryaddress.length > 1) {
      var descsecondaryaddresslist = _.orderBy(this.secondaryaddress, [(obj) => new Date(obj.modifiedOn)], ['desc']);
      this.dataSource1.data = descsecondaryaddresslist.slice(1);
    }
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);

  }
  ngOnInit() {
    this.addresshistoryform = this.formBuilder.group({

    });

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
